import React, { useState, useEffect } from "react";
import Logo from "../Assets/navlogo.png";
import { Link } from "react-router-dom";
import bg from "../Assets/bg-img.png";
// import { useState } from "react";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scroll, setScroll] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [mobM, setMobM] = useState("-translate-y-96");

  const toggleMenu = () => {
    // setShowMenu(prevShowMenu => !prevShowMenu);
    if (showMenu === false) {
      setShowMenu(true);
    } else {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    // if (scrollPosition >= 200) {
    //   setScroll(true);
    // }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

    // handleScroll()
  });

  useEffect(() => {
    if (showMenu === true) {
      setMobM("translate-y-0");
    } else {
      setMobM("-translate-y-96");
    }
  }, [showMenu]);

  return (
    <>
      <nav
        className={` ${
          scrollPosition >= 200
            ? "bg-white text-black shadow-lg tr"
            : "bg-transparent text-white"
        }  duration-300 z-[30]`}
      >
        <div className='max-w-6xl mx-auto px-4'>
          <div className='flex justify-between w-full'>
            {/* <div className='flex  items-center w-[80%]'> */}
            <div className=''>
              <div className=''>
                <Link to='/' className='flex items-center py-4 px-2'>
                  <img src={Logo} alt='Logo' className='h-8 w-8 mr-2' />
                  <span className='font-semibold  text-lg'>OPC</span>
                </Link>
              </div>
            </div>
            {/* Primary Navbar items */}
            <div className='hidden lg:flex items-center space-x-5'>
              <Link
                to='/'
                className='py-4 px-2 font-semibold hover:text-green-500 transition duration-300'
              >
                HOME
              </Link>
              <Link
                to={`/about-us`}
                className='py-4 px-2 font-semibold hover:text-green-500 transition duration-300'
              >
                ABOUT US
              </Link>
              <Link
                to='/projects'
                className='py-4 px-2  font-semibold hover:text-green-500 transition duration-300'
              >
                PROJECTS
              </Link>
              <Link
                to='/contact-us'
                className='py-4 px-2  font-semibold hover:text-green-500 transition duration-300'
              >
                CONTACT US
              </Link>
              <Link
                to='/gallery'
                className='py-4 px-2  font-semibold hover:text-green-500 transition duration-300'
              >
                GALLARY
              </Link>
            </div>
            {/* Secondary Navbar items */}
            <div className='hidden lg:flex items-center space-x-3'>
              {/* <Link
                to='/login'
                className='py-2 px-2 font-medium text-gray-500 rounded hover:bg-green-500 hover:text-white transition duration-300'
              >
                Log In
              </Link> */}
              <button>
                <Link
                  to={"/donate"}
                  className='hover:scale-95 transition duration-1000 ease-in-out bg-green-600 text-white font-bold px-8 md:px-11 py-3 flex items-center'
                >
                  <h1 className='border-b-2 w-8 mx-2 border-white'></h1>
                  <h1>Donate</h1>
                </Link>
              </button>
            </div>
            {/* Mobile menu button */}
            <div className='lg:hidden flex items-center'>
              <button
                className='outline-none mobile-menu-button'
                onClick={toggleMenu}
              >
                <svg
                  className={`w-6 h-6 text-gray-500`}
                  fill='none'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
                >
                  <path d='M4 6h16M4 12h16M4 18h16'></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        {/* mobile menu */}
        {/* <div
          className={`mobile-menu ${
            showMenu ? "" : "hidden"
          } lg:hidden bg-white text-black`}
        > */}
        <div
          className={`absolute ${mobM}  mobile-menu  w-screen lg:hidden bg-white text-black duration-500 ease-in-out`}
        >
          <ul>
            <li className='active'>
              <Link
                to='/'
                className='block text-sm px-2 py-4  border-b-2 hover:border-b-green-700 hover:border-b-2 transition duration-300'
              >
                HOME
              </Link>
            </li>
            <li>
              <Link
                to='/about-us'
                className='block text-sm px-2 py-4  border-b-2 hover:border-b-green-700 hover:border-b-2 transition duration-300'
              >
                ABOUT US
              </Link>
            </li>
            <li>
              <Link
                to='/projects'
                className='block text-sm px-2 py-4  border-b-2 hover:border-b-green-700 hover:border-b-2 transition duration-300'
              >
                PROJECTS
              </Link>
            </li>
            <li>
              <Link
                to='/contact-us'
                className='block text-sm px-2 py-4  border-b-2 hover:border-b-green-700 hover:border-b-2 transition duration-300'
              >
                CONTACT US
              </Link>
            </li>
            <li>
              <Link
                to='/gallery'
                className='block text-sm px-2 py-4  border-b-2 hover:border-b-green-700 hover:border-b-2 transition duration-300'
              >
                GALLERY
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;

{
  /* <div className=''>
      <div className='navbar bg-base-100'>
        <div className='navbar-start'>
          <div className='dropdown'>
            <label tabIndex={0} className='btn btn-ghost lg:hidden'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-5 w-5'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M4 6h16M4 12h8m-8 6h16'
                />
              </svg>
            </label>
            <ul
              tabIndex={0}
              className='menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52'
            >
              <li>
                <a>Item 1</a>
              </li>
              <li>
                <a>Parent</a>
                <ul className='p-2'>
                  <li>
                    <a>Submenu 1</a>
                  </li>
                  <li>
                    <a>Submenu 2</a>
                  </li>
                </ul>
              </li>
              <li>
                <a>Item 3</a>
              </li>
            </ul>
          </div>
          <a className='btn btn-ghost normal-case text-xl'>daisyUI</a>
        </div>
        <div className='navbar-center hidden lg:flex'>
          <ul className='menu menu-horizontal px-1'>
            <li>
              <a>Item 1</a>
            </li>
            <li tabIndex={0}>
              <details>
                <summary>Parent</summary>
                <ul className='p-2'>
                  <li>
                    <a>Submenu 1</a>
                  </li>
                  <li>
                    <a>Submenu 2</a>
                  </li>
                </ul>
              </details>
            </li>
            <li>
              <a>Item 3</a>
            </li>
          </ul>
        </div>
        <div className='navbar-end'>
          <a className='btn'>Button</a>
        </div>
      </div>
    </div> */
}

//  <div className='block items-center font-extrabold slg:hidden space-y-11  px-4'>
//    <Link>
//      <h1 className='text-yellow-400 py-3 border-b-2 hover:text-green-600 hover:border-b-2 border-b-green-600 transition-colors duration-500 ease-in-out'>
//        HOME
//      </h1>
//    </Link>
//    <Link>
//      <h1 className='text-yellow-400 py-2 border-b-2 hover:text-green-600 hover:border-b-2 border-b-green-600 transition-all duration-500 ease-in-out'>
//        ABOUT US
//      </h1>
//    </Link>
//    <Link>
//      <h1 className='text-green-600 py-2 border-b-2 hover:text-yellow-400 hover:border-b-2 border-b-yellow-400 transition-colors duration-500 ease-in-out'>
//        PROJECT
//      </h1>
//    </Link>
//    <Link>
//      <h1 className='text-green-600 py-2 border-b-2 hover:text-yellow-400 hover:border-b-2 border-b-yellow-400 transition-colors duration-500 ease-in-out'>
//        DONATE
//      </h1>
//    </Link>
//    <Link>
//      <h1 className='text-green-600 py-2 border-b-2 hover:text-yellow-400 hover:border-b-2 border-b-yellow-400 transition-colors duration-500 ease-in-out'>
//        GALLERY
//      </h1>
//    </Link>
//  </div>;
